import { render, staticRenderFns } from "./FamilyList.vue?vue&type=template&id=2f0b84d8&scoped=true&"
import script from "./FamilyList.vue?vue&type=script&lang=js&"
export * from "./FamilyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b84d8",
  null
  
)

export default component.exports